import axios from "axios";

export default {
  namespaced: true,
  state: {
    batchpayments: [],
    query: {},
    isReceiving: false,
    isUpdating: false,
    isDeleting: false,
    idToDelete: null,
    batchpaymentsMessage: ''
  },
  mutations: {
    DO_NOTHING(state) {
      state.isReceiving = false;
    },
    FINDING_BATCH_PAYMENTS(state, payload) {
      state.isReceiving = true;
      state.query = Object.assign({}, payload);
    },
    RECEIVED_BATCH_PAYMENTS(state, payload) {
      state.batchpayments = payload;
      state.isReceiving = false;
    },
    RECEIVING_BATCH_PAYMENTS(state) {
      state.isReceiving = true;
    },
    RECEIVED_BATCH_PAYMENT(state, payload) {
      state.isReceiving = false;
      let find = state.batchpayments.find(i=>i._id==payload._id);
      if(find==null){
        state = Object.assign(state, { batchpayments: [payload, ...state.batchpayments] });
      }
      else {
        let index = state.batchpayments.findIndex(x => x._id==payload._id);
        state.batchpayments.splice(index, 1, payload);
      }
    },
    RECEIVING_BATCH_PAYMENT(state) {
      state.isReceiving = true;
    },
    UPDATED_BATCH_PAYMENT(state, payload) {
      console.log(state.batchpayments);
      console.log(payload);
      let index = state.batchpayments.findIndex(batchpayment => batchpayment._id === payload._id);
      state = Object.assign(state, {
        batchpayments: state.batchpayments.map((batchpayment, i) => {
          if (i === index) {
            return Object.assign({}, batchpayment, payload);
          }
          return batchpayment;
        }),
        isUpdating: false,
        batchpaymentsMessage: 'BatchPayments has been updating!',
      })
    },
    UPDATING_BATCH_PAYMENT(state) {
      state.isUpdating = true;
    },
    DELETED_BATCH_PAYMENT(state, payload) {
      let indexToDelete = state.batchpayments.findIndex(batchpayment => batchpayment._id === payload._id);
      let batchpayments = [...state.batchpayments];
      batchpayments.splice(indexToDelete, 1);
      state = Object.assign(state, {
        batchpayments: [...batchpayments],
        isDeleting: false,
        idToDelete: null,
        batchpaymentsMessage: 'BatchPayment has been Deleted!',
      });
    },
    DELETING_BATCH_PAYMENT(state, payload) {
      state.isDeleting = true;
      state.idToDelete = payload.id;
    },
  },
  actions: {
    async deleteBatchPaymentRequest({dispatch}, payload) {
      dispatch("deletingBatchPayment", payload);
      let token = localStorage.getItem('token')
      let url = 'https://api.tradexc.com:3000/delete/batchpayment/' + payload._id;
      let headers = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      return axios({method: "delete", url: url, headers: headers})
      .then(response=>{
        dispatch("deleteBatchPayment", response.data);
      })
    },
    async getBatchPaymentsRequest({dispatch}) {
      dispatch("receivingBatchPayments");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/batchpayments';
      let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      return axios({method: "get", url: url,headers: headers})
      .then(res => {
        console.log('111', res.data);
        dispatch("receiveBatchPayments", res.data);
      })
    },
    async getBatchPaymentRequest({dispatch}, id) {
      dispatch("receivingBatchPayments");
      let token = localStorage.getItem('token');
      let url = 'https://api.tradexc.com:3000/get/batchpayment/' + id;
      let header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};
      let response = await axios({method: "get",url: url,headers: header});
      dispatch("receiveBatchPayment", response.data);
      return response.data;
    },
    async findBatchPaymentsQueryRequest({dispatch}, payload) {
      try{
        dispatch("findingBatchPayments", payload);
        let token = localStorage.getItem('token');
        console.log(token)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/find/batchpayments';
        let response = await axios({method: "POST", url: url, headers: headers, data: payload});
        dispatch("doNothing");
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    async insertBatchPaymentRequest({dispatch}, payload) {
      dispatch("receivingBatchPayments");
      let data = payload;
      console.log(payload)
      let token = localStorage.getItem('token');
      console.log(token)
      let url = 'https://api.tradexc.com:3000/insert/batchpayment'; 
      let header = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
      await axios({method: "post", url: url, headers: header, data: data})
      .then(response=> {
        dispatch("receiveBatchPayment", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });	
    },
    async updateBatchPaymentRequest({dispatch}, payload) {
      dispatch("updatingBatchPayment");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/batchpayment/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      return axios({method:"put", url:url, headers:header, data:payload})
      .then((response)=> {
        dispatch("updateBatchPayment", response.data);
      })
      .catch((error) => {
        this.alertmessage = error;
      });
    },
    async updateBatchPaymentPendingRequest({dispatch}, payload) {
      dispatch("updatingBatchPayment");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/batchpayment/pending/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updateBatchPayment", response.data);
      return response.data;
    },
    async updateBatchPaymentConfirmRequest({dispatch}, payload) {
      dispatch("updatingBatchPayment");
      var id = payload._id;
      delete payload['_id'];
      var token = localStorage.getItem('token');
      var url = 'https://api.tradexc.com:3000/update/batchpayment/confirm/' + id;
      var header = {'Content-Type': 'application/json', 'Authorization': 'Bearer ' + token};

      let response = await axios({method:"put", url:url, headers:header, data:payload})
      dispatch("updateBatchPayment", response.data);
      return response.data;
    },
    async updateBatchPaymentTransaction({dispatch}, payload) {
      try{
        dispatch("updatingBatchPayment");
        let id = payload._id;
        delete payload['_id'];
        let token = localStorage.getItem('token');
        console.log(payload)
        let headers = {'Content-Type': 'application/json','Authorization': 'Bearer ' + token};
        let url = 'https://api.tradexc.com:3000/update/bptransaction/' + id;
        let response = await axios({method: "PUT", url: url, headers: headers, data: payload});
        console.log('response', response.data)
        dispatch("updateBatchPayment", response.data);
        return response.data;
      }
      catch(e){
        return null;
      }
    },
    doNothing({commit}) {
      commit("DO_NOTHING")
    },
    findingBatchPayments({commit}, payload) {
      commit("FINDING_BATCH_PAYMENTS", payload)
    },
    receiveBatchPayments({commit}, payload) {
      commit("RECEIVED_BATCH_PAYMENTS", payload)
    },
    receiveBatchPayment({commit}, payload) {
      commit("RECEIVED_BATCH_PAYMENT", payload)
    },
    receivingBatchPayments({commit}) {
      commit("RECEIVING_BATCH_PAYMENTS")
    },
    receivingBatchPayment({commit}) {
      commit("RECEIVING_BATCH_PAYMENT")
    },
    updateBatchPayment({commit}, payload) {
      commit("UPDATED_BATCH_PAYMENT", payload)
    },
    updatingBatchPayment({commit}) {
      commit("UPDATING_BATCH_PAYMENT")
    },
    deleteBatchPayment({commit}, payload) {
      commit("DELETED_BATCH_PAYMENT", payload)
    },
    deletingBatchPayment({commit}, payload) {
      commit("DELETING_BATCH_PAYMENT", payload)
    }
  },
};
